import { Component, computed, OnInit, signal, Signal, WritableSignal } from '@angular/core';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { ParticipantService } from '@shared/services/participant/participant.service';
import { PlIcon } from '@app/icon-library/icons';
import { AuthenticationService } from '@app/auth';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'pl-profile-details-tab',
  templateUrl: './detailsTab.component.html',
})
export class DetailsTabComponent implements OnInit {
  public participantFullName: Signal<string> = computed(() => {
    return this.participantService.getParticipantFullName();
  });

  public participantEmail: Signal<string> = computed(() => {
    return this.participantService.participant()?.email || '';
  });

  public resetPasswordEmailSent: WritableSignal<boolean> = signal(false);
  public disableSendEmailButton: WritableSignal<boolean> = signal(false);
  public errorSendingEmail: WritableSignal<boolean> = signal(false);

  public readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
  public readonly PlIcon: typeof PlIcon = PlIcon;

  constructor(
    private authenticationService: AuthenticationService,
    private participantService: ParticipantService,
  ) {}

  public ngOnInit(): void {
    console.log('\x1b[41m TONIO CertificatesTabComponent ngOnInit =', '\x1b');
  }
  public sendResetPasswordEmail(): void {
    console.log('TONIO CertificatesTabComponent sendResetPasswordEmail =');
    this.disableSendEmailButton.set(true);
    this.authenticationService.forgotPassword(this.participantEmail()).subscribe({
      next: (): void => {
        this.resetPasswordEmailSent.set(true);
        this.errorSendingEmail.set(false);
      },
      error: (error: HttpErrorResponse): void => {
        console.error('There was an error sending reset password email, error=', error);
        this.disableSendEmailButton.set(false);
        this.errorSendingEmail.set(true);
      },
    });
  }
}
